import { FC } from 'react';

import './style.scss';

export const ArticleLargeImageSkeleton = () => {
  return <div className="article-large-image-skeleton" />;
};

export const ArticleAuthorSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-author-skeleton">
      <svg xmlns="http://www.w3.org/2000/svg" width="375" height="57" viewBox="0 0 375 57" fill="none">
        <circle cx="34" cy="28.5" r="18" fill="#e6e6e6" />
        <rect x="60" y="22.5" width="72" height="12" rx="4" fill="#e6e6e6" />
        <rect x="271" y="14.5" width="88" height="28" rx="4" fill="#e6e6e6" />
      </svg>
    </div>
  );
};

export const ArticleTitleSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-title-skeleton">
      <svg xmlns="http://www.w3.org/2000/svg" width="160" height="28" viewBox="0 0 160 28" fill="none">
        <rect width="160" height="28" rx="4" fill="#e6e6e6" />
      </svg>
    </div>
  );
};

export const ArticleContentSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-content-skeleton">
      <div key="article-content-skeleton-item0" className="svg-skeleton article-content-skeleton-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="343" height="16" viewBox="0 0 343 16" fill="none">
          <rect width="343" height="16" rx="4" fill="#e6e6e6" />
        </svg>
      </div>
      <div key="article-content-skeleton-item1" className="svg-skeleton article-content-skeleton-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="343" height="16" viewBox="0 0 343 16" fill="none">
          <rect width="343" height="16" rx="4" fill="#e6e6e6" />
        </svg>
      </div>
      <div key="article-content-skeleton-item2" className="svg-skeleton article-content-skeleton-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="343" height="16" viewBox="0 0 343 16" fill="none">
          <rect width="343" height="16" rx="4" fill="#e6e6e6" />
        </svg>
      </div>
    </div>
  );
};

export const ArticleCommentSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-comment-skeleton">
      <svg xmlns="http://www.w3.org/2000/svg" width="375" height="168" viewBox="0 0 375 168" fill="none">
        <rect x="16" width="80" height="24" rx="4" fill="#e6e6e6" />
        <rect width="374" height="68" transform="translate(0 32)" fill="white" />
        <circle cx="40" cy="66" r="24" fill="#e6e6e6" />
        <rect x="76" y="51" width="72" height="12" rx="4" fill="#e6e6e6" />
        <rect x="76" y="69" width="160" height="12" rx="4" fill="#e6e6e6" />
        <rect width="374" height="68" transform="translate(0 100)" fill="white" />
        <circle cx="40" cy="134" r="24" fill="#e6e6e6" />
        <rect x="76" y="119" width="100" height="12" rx="4" fill="#e6e6e6" />
        <rect x="76" y="137" width="160" height="12" rx="4" fill="#e6e6e6" />
      </svg>
    </div>
  );
};

export const ArticleImmersivePostSkeleton: FC = () => {
  return (
    <div className="svg-skeleton article-immersive-post-skeleton">
      <svg width="375" height="742" viewBox="0 0 375 742" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="375" height="742" fill="white" />
        <rect width="375" height="500" transform="translate(0 56)" fill="#F2F2F2" />
        <rect width="375" height="500" transform="translate(0 56)" fill="#F2F2F2" />
        <g clipPath="url(#clip0_41_6771)">
          <circle cx="34" cy="28" r="18" fill="#F2F2F2" />
          <rect x="60" y="22" width="72" height="12" rx="4" fill="#F2F2F2" />
        </g>
        <rect x="16" y="612" width="160" height="28" rx="4" fill="#F2F2F2" />
        <rect x="16" y="650" width="343" height="16" rx="4" fill="#F2F2F2" />
        <rect x="16" y="676" width="343" height="16" rx="4" fill="#F2F2F2" />
        <rect x="16" y="702" width="223" height="16" rx="4" fill="#F2F2F2" />
        <rect x="287" y="14" width="72" height="28" rx="2" fill="#F2F2F2" />
        <rect x="16" y="568" width="72" height="28" rx="2" fill="#F2F2F2" />
        <rect x="203.5" y="568" width="72" height="28" rx="2" fill="#F2F2F2" />
        <rect x="287" y="568" width="72" height="28" rx="2" fill="#F2F2F2" />
        <defs>
          <clipPath id="clip0_41_6771">
            <rect width="116" height="36" fill="white" transform="translate(16 10)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
